export default __webpack_public_path__ + "media/BusinessMentorship.549b76ac.svg";